import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import Input from "../../../../../components/form/Input";
import Button from "../../../../../components/form/Button";
import DateTimePicker from "../../../../../components/form/DateTime";
import CroField from "../../../components/generalForm/CroField";
import CroLabeledCmp from "../../../components/generalForm/CroLabeledCmp";
import { asyncForm } from "../../../../../utils/asyncForm";
import * as V from "../../../../../utils/formValidation";
import { styles } from "../../../index";
import { isUndefined } from "lodash";
import askAction from "../../AskAction";

class DictionaryForm extends Component {
  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      disabled,
      submitting,
      goBack,
      onDelete,
      askAction,
    } = this.props;
    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form dictionaryForm"
      >
        <div className="dictionaryForm__section">
          <div className="dictionaryForm__grid">
            <CroField
              className="full"
              title="Název"
              name="name"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="full"
              title="Vytvořeno"
              name="created"
              component={DateTimePicker}
              fullWidth
              disabled
            />
          </div>
        </div>
        <Field
          name="order"
          component={Input}
          type="hidden"
          style={{ display: "none" }}
        />
        <Field
          name="active"
          component={Input}
          type="hidden"
          style={{ display: "none" }}
        />

        {!disabled && (
          <div className="dictionaryForm__footer">
            <div className="dictionaryForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}

              <div className="dictionaryForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
                {!isUndefined(onDelete) && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Smazat"
                    disabled={submitting || disabled}
                    onClick={askAction(onDelete)}
                  />
                )}
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zpět"
                  onClick={goBack}
                />
              </div>
            </div>
          </div>
        )}
      </form>
    );
  }
}

export default reduxForm({
  form: "dictionaryForm",
})(askAction(asyncForm(DictionaryForm)));
